import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72b1357c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between items-center" }
const _hoisted_2 = {
  key: 0,
  class: "label-block"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Remove")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_dispatch_renderer = _resolveComponent("dispatch-renderer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.control.uischema.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.control.uischema.label), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_q_btn, {
        round: "",
        icon: "add",
        class: "btn--no-hover",
        flat: "",
        small: "",
        disabled: _ctx.addDisabled,
        onClick: _ctx.addButtonClick
      }, {
        default: _withCtx(() => [
          (!_ctx.addDisabled)
            ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.control.data, (_element, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["flex no-wrap q-mb-lg", _ctx.control.uischema.options.detail.class]),
        style: {"width":"100%"}
      }, [
        (_openBlock(), _createBlock(_component_dispatch_renderer, {
          key: `${_ctx.control.path}-${index}`,
          schema: _ctx.control.schema,
          isNew: _ctx.freezeManifest.zones && _ctx.freezeManifest.zones.length < index + 1,
          uischema: _ctx.foundUISchema,
          path: _ctx.composePaths(_ctx.control.path, `${index}`),
          enabled: _ctx.control.enabled,
          renderers: _ctx.control.renderers,
          cells: _ctx.control.cells,
          manifest: _ctx.manifest,
          freezeManifest: _ctx.freezeManifest,
          currentEnv: _ctx.currentEnv
        }, null, 8, ["schema", "isNew", "uischema", "path", "enabled", "renderers", "cells", "manifest", "freezeManifest", "currentEnv"])),
        _createVNode(_component_q_btn, {
          flat: "",
          round: "",
          small: "",
          icon: "delete",
          style: {"width":"30px"},
          class: "btn--no-hover",
          disabled: _ctx.canBeDelete(_element),
          onClick: ($event: any) => {
        _ctx.removeItemsClick($event, [index]);
        _ctx.suggestToDelete = null;
      }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["disabled", "onClick"])
      ], 2))
    }), 128))
  ], 64))
}